import { StandardApiResponse, StandardPagedData } from '../interfaces/standard-api-response.interface';

export function extractResponseData<T>(response: StandardApiResponse<T> | null | undefined): T | null {
  return response?.data ?? null;
}

export function extractPagedItems<T>(
  response: StandardApiResponse<StandardPagedData<T>> | null | undefined,
): T[] {
  return response?.data?.content ?? [];
}

export function extractPagedTotal<T>(
  response: StandardApiResponse<StandardPagedData<T>> | null | undefined,
  fallbackCount = 0,
): number {
  return response?.data?.totalElements ?? fallbackCount;
}
